
const newModel = () => {
    return {
        rolesGroupId: null,
        ten: null,
        moTa: null,
        ghiChu: null,
        appId: null,
        appName: null,
        stt: null,
        enabled: null,
        enabledDisplay: null,
    }
}

const newFEModel = () => {
    return {
        rolesGroupId: null,
        ten: null,
        moTa: null,
        ghiChu: null,
        appId: null,
        stt: null,
        enabled: null,
        enabledDisplay: null,
    }
}

const fromJson = (item) => {
    return {
        rolesGroupId: item.rolesGroupId,
        ten: item.ten,
        moTa: item.moTa,
        ghiChu: item.ghiChu,
        appId: item.appId,
        appName: item.appName,
        stt: item.stt,
        enabled: item.enabled,
        enabledDisplay: item.enabled == 1 ? true : false
    }
}

const parseModeltoFEModel = (item) => {
    return {
        rolesGroupId: item.rolesGroupId,
        ten: item.ten,
        moTa: item.moTa,
        ghiChu: item.ghiChu,
        appId: item.appId,
        stt: item.stt,
        enabled: item.enabled,
        enabledDisplay: item.enabled == 1 ? true : false
    }
}

const errors = () => {
    return {
        rolesGroupId: null,
        ten: null,
        moTa: null,
        ghiChu: null,
        appId: null,
        stt: null,
        enabled: null,
        enabledDisplay: null
    }
}

export const nhomQuyenModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    fromJson,
    errors,
}


